<template>
  <div id="banner">
    <!-- 面包导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 轮播图列表卡片区 -->
    <el-card class="box-card">
      <el-form :inline="true" ref="form" :model="queryMap" label-width="70px">
        <el-form-item label="标题">
          <el-input
            @keyup.enter.native="searchBanner"
            @clear="searchBanner"
            clearable
            v-model="queryMap.title"
            placeholder="请输入Banner标题查询"
          ></el-input>
        </el-form-item>

        <el-form-item label="位置">
          <el-select
            clearable
            @change="searchBanner"
            @clear="searchBanner"
            v-model="queryMap.position"
            placeholder="请选择展示位置"
          >
            <el-option label="首页顶部" value="1"></el-option>
            <el-option label="分类页顶部" value="2"></el-option>
            <el-option label="其他位置" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            clearable
            @change="searchBanner"
            @clear="searchBanner"
            v-model="queryMap.status"
            placeholder="请选择状态"
          >
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left: 50px">
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button type="primary" @click="searchBanner" icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addDialogVisible = true"
            v-hasPermission="'banner:add'"
            >添加</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="bannerList"
        border
        style="width: 100%"
        height="660"
      >
        <el-table-column label="#" prop="id" width="50"></el-table-column>
        <el-table-column
          prop="title"
          label="Banner标题"
          width="180"
        ></el-table-column>
        <el-table-column label="图片预览" width="120">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.imageUrl"
              :preview-src-list="[scope.row.imageUrl]"
              style="width: 80px; height: 45px; object-fit: cover"
              placeholder="暂无图片"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="jumpType" label="跳转类型" width="120">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="scope.row.jumpType === 3 ? 'info' : 'primary'"
            >
              {{ formatJumpType(scope.row.jumpType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="position" label="展示位置" width="120">
          <template slot-scope="scope">
            {{ formatPosition(scope.row.position) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序权重"
          width="100"
        ></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="生效开始时间"
          width="180"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-hasPermission="'banner:edit'"
              size="mini"
              type="primary"
              icon="el-icon-edit-outline"
              @click="edit(scope.row.id)"
            ></el-button>
            <el-button
              v-hasPermission="'banner:delete'"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="del(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[6, 10, 20, 30]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <!-- 添加对话框 -->
      <el-dialog
        title="添加轮播图"
        @close="closeDialog"
        :visible.sync="addDialogVisible"
        width="60%;"
      >
        <el-form
          :model="addForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="addFormRef"
          label-width="100px"
        >
          <el-form-item label="Banner标题" prop="title">
            <el-input
              v-model="addForm.title"
              placeholder="请输入管理用标题"
            ></el-input>
          </el-form-item>

          <el-form-item label="图片上传" prop="imageUrl">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">点击上传图片</el-button>
            </el-upload>

            <el-image
              v-if="addForm.imageUrl"
              :src="addForm.imageUrl"
              style="
                width: 300px;
                height: 160px;
                margin-top: 10px;
                object-fit: cover;
              "
            ></el-image>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="图片宽度(px)" prop="imageWidth">
                <el-input
                  v-model.number="addForm.imageWidth"
                  placeholder="可选，自动获取"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片高度(px)" prop="imageHeight">
                <el-input
                  v-model.number="addForm.imageHeight"
                  placeholder="可选，自动获取"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="跳转类型" prop="jumpType">
            <el-radio-group
              v-model="addForm.jumpType"
              @change="handleJumpTypeChange"
            >
              <el-radio :label="1">小程序内页面</el-radio>
              <el-radio :label="2">外部H5链接</el-radio>
              <el-radio :label="3">无跳转</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="跳转链接"
            prop="jumpUrl"
            :rules="
              addForm.jumpType !== 3
                ? [
                    {
                      required: true,
                      message: '请输入跳转链接',
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <el-input
              v-model="addForm.jumpUrl"
              placeholder="小程序路径或H5链接"
            ></el-input>
          </el-form-item>

          <el-form-item label="展示位置" prop="position">
            <el-select v-model="addForm.position" placeholder="请选择展示位置">
              <el-option label="首页顶部" value="1"></el-option>
              <el-option label="分类页顶部" value="2"></el-option>
              <el-option label="其他位置" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="addForm.sort"
              placeholder="越小越靠前，默认0"
            ></el-input>
            <div style="font-size: 12px; color: #888; margin-top: 5px">
              提示：数值越小，展示时越靠前
            </div>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-switch
              v-model="addForm.status"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="生效开始时间" prop="startTime">
                <el-date-picker
                  type="datetime"
                  v-model="addForm.startTime"
                  placeholder="选择开始时间"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效结束时间" prop="endTime">
                <el-date-picker
                  type="datetime"
                  v-model="addForm.endTime"
                  placeholder="选择结束时间"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addBanner"
            :loading="btnLoading"
            :disabled="btnDisabled"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 编辑对话框 -->
      <el-dialog
        title="编辑轮播图"
        :visible.sync="editDialogVisible"
        width="60%"
        @close="editClose"
      >
        <el-form
          :model="editForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="editFormRef"
          label-width="100px"
        >
          <el-input type="hidden" v-model="editForm.id"></el-input>

          <el-form-item label="Banner标题" prop="title">
            <el-input
              v-model="editForm.title"
              placeholder="请输入管理用标题"
            ></el-input>
          </el-form-item>

          <el-form-item label="当前图片">
            <el-image
              :src="editForm.imageUrl"
              style="width: 300px; height: 160px; object-fit: cover"
              placeholder="暂无图片"
            ></el-image>
          </el-form-item>

          <el-form-item label="更换图片">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">点击上传新图片</el-button>
            </el-upload>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="图片宽度(px)" prop="imageWidth">
                <el-input v-model.number="editForm.imageWidth"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片高度(px)" prop="imageHeight">
                <el-input v-model.number="editForm.imageHeight"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="跳转类型" prop="jumpType">
            <el-radio-group
              v-model="editForm.jumpType"
              @change="handleEditJumpTypeChange"
            >
              <el-radio :label="1">小程序内页面</el-radio>
              <el-radio :label="2">外部H5链接</el-radio>
              <el-radio :label="3">无跳转</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="跳转链接"
            prop="jumpUrl"
            :rules="
              editForm.jumpType !== 3
                ? [
                    {
                      required: true,
                      message: '请输入跳转链接',
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <el-input
              v-model="editForm.jumpUrl"
              placeholder="小程序路径或H5链接"
            ></el-input>
          </el-form-item>

          <el-form-item label="展示位置" prop="position">
            <el-select v-model="editForm.position" placeholder="请选择展示位置">
              <el-option label="首页顶部" value="1"></el-option>
              <el-option label="分类页顶部" value="2"></el-option>
              <el-option label="其他位置" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="editForm.sort"
              placeholder="越小越靠前"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-switch
              v-model="editForm.status"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="生效开始时间" prop="startTime">
                <el-date-picker
                  type="datetime"
                  v-model="editForm.startTime"
                  placeholder="选择开始时间"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效结束时间" prop="endTime">
                <el-date-picker
                  type="datetime"
                  v-model="editForm.endTime"
                  placeholder="选择结束时间"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updateBanner"
            :loading="btnLoading"
            :disabled="btnDisabled"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 基础状态
      loading: true,
      btnLoading: false,
      btnDisabled: false,
      labelPosition: "right",
      total: 0,

      // 对话框控制
      addDialogVisible: false,
      editDialogVisible: false,

      // 查询参数
      queryMap: {
        pageNum: 1,
        pageSize: 6,
        title: "",
        position: "",
        status: "",
      },

      // 数据列表
      bannerList: [],

      // 表单数据
      addForm: {
        title: "",
        imageUrl: "",
        imageWidth: null,
        imageHeight: null,
        jumpType: 3,
        jumpUrl: "",
        position: 1,
        status: 1,
        sort: 0,
        startTime: null,
        endTime: null,
      },
      editForm: {},

      // 表单验证规则
      formRules: {
        title: [
          { required: true, message: "请输入Banner标题", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "标题长度在2-50个字符之间",
            trigger: "blur",
          },
        ],
        // imageUrl: [
        //   { required: true, message: "请上传Banner图片", trigger: "blur" },
        // ],
        position: [
          { required: true, message: "请选择展示位置", trigger: "blur" },
        ],
        sort: [
          { type: "number", message: "排序权重必须为数字", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请选择生效开始时间", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 格式化跳转类型显示文本
    formatJumpType(type) {
      const typeMap = {
        1: "小程序内页",
        2: "外部H5",
        3: "无跳转",
      };
      return typeMap[type] || "未知";
    },

    // 格式化位置显示文本
    formatPosition(position) {
      const posMap = {
        1: "首页顶部",
        2: "分类页顶部",
        3: "其他位置",
      };
      return posMap[position] || "未知位置";
    },

    // 加载轮播图列表
    async getBannerList() {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get("banner/list", {
          params: this.queryMap,
        });
        if (res.code !== 200) return this.$message.error("获取轮播图列表失败");
        this.bannerList = res.data.rows;
        this.total = res.data.total;
      } catch (error) {
        this.$message.error("获取数据失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 搜索轮播图
    searchBanner() {
      this.queryMap.pageNum = 1;
      this.getBannerList();
    },

    // 重置查询条件
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 6,
        title: "",
        position: "",
        status: "",
      };
      this.getBannerList();
    },

    // 分页相关
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getBannerList();
    },
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getBannerList();
    },

    // 图片上传成功回调
    handleUploadSuccess(response) {
      if (response.code === 200) {
        this.addForm.imageUrl = response.data.url;
        // 自动获取图片尺寸（实际项目可能需要后端返回或前端处理）
        const img = new Image();
        img.onload = () => {
          this.addForm.imageWidth = img.width;
          this.addForm.imageHeight = img.height;
        };
        img.src = response.data.url;
        this.$message.success("图片上传成功");
      } else {
        this.$message.error("图片上传失败：" + response.msg);
      }
    },

    // 编辑页图片上传成功回调
    handleEditUploadSuccess(response) {
      if (response.code === 200) {
        this.editForm.imageUrl = response.data.url;
        const img = new Image();
        img.onload = () => {
          this.editForm.imageWidth = img.width;
          this.editForm.imageHeight = img.height;
        };
        img.src = response.data.url;
        this.$message.success("图片上传成功");
      } else {
        this.$message.error("图片上传失败：" + response.msg);
      }
    },

    // 上传失败回调
    handleUploadError() {
      this.$message.error("图片上传失败，请检查网络");
    },

    // 跳转类型变更处理
    handleJumpTypeChange() {
      if (this.addForm.jumpType === 3) {
        this.addForm.jumpUrl = "";
      }
    },
    handleEditJumpTypeChange() {
      if (this.editForm.jumpType === 3) {
        this.editForm.jumpUrl = "";
      }
    },

    // 添加轮播图
    async addBanner() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.post(
            "banner/add",
            this.addForm
          );
          if (res.code === 200) {
            this.$notify.success({ title: "成功", message: "轮播图添加成功" });
            this.addDialogVisible = false;
            this.getBannerList();
          } else {
            this.$message.error("添加失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("添加失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 编辑轮播图
    async edit(id) {
      try {
        const { data: res } = await this.$http.get(`banner/${id}`);
        if (res.code !== 200) return this.$message.error("获取轮播图详情失败");
        this.editForm = { ...res.data };
        // 转换时间格式（如果后端返回字符串）
        if (this.editForm.startTime)
          this.editForm.startTime = new Date(this.editForm.startTime);
        if (this.editForm.endTime)
          this.editForm.endTime = new Date(this.editForm.endTime);
        this.editDialogVisible = true;
      } catch (error) {
        this.$message.error("获取详情失败，请重试");
      }
    },

    // 更新轮播图
    async updateBanner() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.put(
            `banner/update/${this.editForm.id}`,
            this.editForm
          );
          if (res.code === 200) {
            this.$notify.success({ title: "成功", message: "轮播图更新成功" });
            this.editDialogVisible = false;
            this.getBannerList();
          } else {
            this.$message.error("更新失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("更新失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 删除轮播图
    async del(id) {
      try {
        const confirm = await this.$confirm(
          "此操作将永久删除该轮播图，是否继续？",
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        if (confirm !== "confirm") return;

        const { data: res } = await this.$http.delete(`banner/delete/${id}`);
        if (res.code === 200) {
          this.$notify.success({ title: "成功", message: "轮播图删除成功" });
          this.getBannerList();
        } else {
          this.$message.error("删除失败：" + res.msg);
        }
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("删除失败，请重试");
        }
      }
    },

    // 切换状态
    async changeStatus(row) {
      const originalStatus = row.status;
      console.log(originalStatus);
      try {
        const { data: res } = await this.$http.put(
          `banner/updateStatus/${row.id}/${row.status}`
        );
        if (res.code !== 200) {
          row.status = originalStatus; // 回滚状态
          return this.$message.error("状态更新失败：" + res.msg);
        }
        this.$notify.success({
          title: "成功",
          message: `轮播图已${row.status === 1 ? "启用" : "禁用"}`,
        });
      } catch (error) {
        row.status = originalStatus; // 回滚状态
        this.$message.error("状态更新失败，请重试");
      }
    },

    // 关闭添加对话框
    closeDialog() {
      this.$refs.addFormRef.clearValidate();
      this.addForm = {
        title: "",
        imageUrl: "",
        imageWidth: null,
        imageHeight: null,
        jumpType: 3,
        jumpUrl: "",
        position: 1,
        status: 1,
        sort: 0,
        startTime: null,
        endTime: null,
      };
    },

    // 关闭编辑对话框
    editClose() {
      this.$refs.editFormRef.clearValidate();
      this.editForm = {};
    },

    // 获取Token（根据项目实际认证方式修改）
    getToken() {
      return localStorage.getItem("token") || "";
    },
  },

  created() {
    this.getBannerList();
  },
};
</script>

<style scoped>
.upload-demo {
  margin-bottom: 10px;
}
</style>
